export type TVigencyType =
  | "pluriannual"
  | "annual"
  | "monthly"
  | "daily"
  | "pay_per_use"
  | "lifetime";

export type TProduct = {
  id: string;
  name: string | null;
  type: string;
  /** Referência de integração (ex.: sync Infinity → Soulhub) */
  product_integration_ref?: string | null;
  /** Config JSON for `credit` products (API `credit_product_config`). */
  credit_product_config?: Record<string, unknown> | null;
  /** Config JSON for `warranty_insurance` (Seguro Garantia). */
  warranty_product_config?: Record<string, unknown> | null;
  /** Config JSON for `theft_insurance` (Seguro Roubo e Furto). */
  theft_product_config?: Record<string, unknown> | null;
  /** Config JSON for SoulHub `insurance_assistance` (seção 1 da planilha). */
  assistance_product_config?: Record<string, unknown> | null;
  infinity_sync_as_source?: boolean | null;
  /** Identificador externo para integração (Soulhub) */
  external_product_id?: string | null;
  insurance_company_id: string | null;
  insurance_company_name?: string | null;
  policy_number: string | null;
  cod_sub: string | null;
  susep_code: string | null;
  iof_value?: string | number;
  type_of_vigency: TVigencyType;
  policy_start_date: string | Date | null;
  policy_end_date: string | Date | null;
  min_permitted_age: number | null;
  max_permitted_age: number | null;
  description: string | null;
  insurance_coverages: string | null;
  insurance_benefits: string | null;
  general_conditions: string | null;
  policy_holder: string | null;
  secondary_policy_holder: string | null;
  table_code: string | null;
  insurance_policy_extra_price_code: string | null;
  stipulant_code: string | null;
  sub_stipulant_code: string | null;
  capital_value: number | null;
  premium_value: number | null;
  commission_unique: string | number | null;
  pro_labore_unique: string | number | null;
  commission_lifetime_other_installments: number | null;
  pro_labore_lifetime_other_installments: number | null;
  markup_mode: boolean | null;
  created_at: string | Date;
  updated_at: string | Date;
  capital_ranges: Array<{
    id: string;
    capital_value: number;
    net_premium: number | null;
    premium_value: number;
    description: string | null;
    position?: number;
    code_plan?: string | null;
    net_price?: number | null;
    minimum_price?: number | null;
    maximum_price?: number | null;
    minimum_markup?: number | null;
    maximum_markup?: number | null;
    minimum_markup_mode?: "percentage" | "real_currency";
    maximum_markup_mode?: "percentage" | "real_currency";
    practiced_price?: number | null;
    practiced_price_type?: "minimum" | "maximum";
    liquid_price?: number | null;
    gross_price?: number | null;
    calculated_iof?: number | null;
    iof_value?: number | null;
  }>;
  commission_distribution: Array<{
    id: string;
    agency: string | number;
    commission: string | number;
    pro_labore: string | number;
    position?: number;
  }>;
};

export enum EProductType {
  INSURANCE_AP = "insurance_personal_assistance",
  INSURANCE_VG = "insurance_group_life",
  INSURANCE_ASSISTANCE = "insurance_assistance",
  CREDIT = "credit",
  AUTO = "auto_insurance",
  MOTO = "moto_insurance",
  WARRANTY_INSURANCE = "warranty_insurance",
  THEFT_INSURANCE = "theft_insurance",
}

export type TProductWithCapitalRange = {
  id: string;
  product_id: string;
  name: string;
  capital_value: number;
  premium_value: number;
  description: string;
  type: string;
  type_of_vigency: TVigencyType;
  minimum_price?: number | null;
  plan_name?: string | null;
  insurance_policy_extra_price_id?: string | null;
};
